import {
  LOAD_MOKA_CONFIG_LIST,
  LOAD_MOKA_CONFIG_LOGS_LIST,
  SET_MOKA_CONFIG_LIST,
  SET_MOKA_CONFIG_LOGS_LIST,
  SUBMIT_MOKA_CONFIG_EDIT_FORM,
} from 'state/actionTypes';

export const loadMokaConfigList = () => ({
  type: LOAD_MOKA_CONFIG_LIST,
});

export const setMokaConfigList = (prices, discounts) => ({
  type: SET_MOKA_CONFIG_LIST,
  payload: { prices, discounts },
});

export const submitMokaConfigEditForm = payload => ({
  type: SUBMIT_MOKA_CONFIG_EDIT_FORM,
  payload,
});

export const loadMokaConfigLogs = paging => ({
  type: LOAD_MOKA_CONFIG_LOGS_LIST,
  paging,
});

export const setMokaConfigLogs = (data, paging) => ({
  type: SET_MOKA_CONFIG_LOGS_LIST,
  payload: { data, paging },
});
